import MDAvatar from "components/MDAvatar";
import List from 'layouts/order/List.js';
import ProductReviews from 'layouts/review/ProductReviews';
import ProtectedRoute from "routes/protectedRoutes.js";
import ManageProducts from 'layouts/product/ManageProducts.js';
// @mui icons
import Icon from "@mui/material/Icon";
// Images
import profilePicture from "assets/images/team-3.jpg";
import Dashboard from 'layouts/dashboard';
import ViewProfile from 'layouts/admin/ViewProfile.js';
import ViewSettings from 'layouts/settings/ViewSettings.js';
import LogOut from 'layouts/admin/LogOut.js';
import EmailTemplates from 'layouts/settings/EmailTemplates.js';
import ManageVendors from 'layouts/vendor/ManageVendors.js';
import AddVendor from 'layouts/vendor/AddVendor.js';
import ManageWithdrawals from 'layouts/withdrawal/ManageWithdrawals';
import ManageCategories from 'layouts/category/ManageCategories.js';
import AddCategory from 'layouts/category/AddCategory.js';
import ManageCollections from 'layouts/collection/ManageCollections.js';
import AddCollection from 'layouts/collection/AddCollection.js';
import ManageCustomField from 'layouts/customfield/ManageCustomField.js';
import AddCustomField from 'layouts/customfield/AddCustomField.js';
import Person4Icon from '@mui/icons-material/Person4';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import CategoryIcon from '@mui/icons-material/Category';
import CollectionsIcon from '@mui/icons-material/Collections';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import SettingsIcon from '@mui/icons-material/Settings';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import Product from "layouts/product/Product";
import ReviewsIcon from '@mui/icons-material/Reviews';
import Role from "layouts/roles/Role";
import Subadmin from "layouts/subadmin/Subadmin";
import ManageSubadmins from "layouts/subadmin/ManageSubadmins";
import ManageRoles from "layouts/roles/Manage";
import { checkPrivilege } from "common.js";
import PersonPinCircleSharpIcon from '@mui/icons-material/PersonPinCircleSharp';
import WebStoriesIcon from '@mui/icons-material/WebStories';
import CustomerList from 'layouts/customer/CustomerList.js';
import ReturnRequests from "layouts/returnRequest/List";
import ManageServices from "layouts/services/Manage";
import Service from "layouts/services/Service";
import Refunds from "layouts/refunds/List";
import ManageTickets from "layouts/tickets/ManageTickets";
import ChatIcon from '@mui/icons-material/Chat';
import { PRIVILEGE, CUSTOM_FIELD, COLLECTION, CATEGORY } from "constants";
import InfoLog from "layouts/infolog/InfoLog";
import BulkUpload from "layouts/product/BulkUpload";

var routes = [];
const adminType = window.localStorage.getItem('type');

if (adminType == PRIVILEGE.ADMIN) {
  routes = [
    {
      type: "collapse",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="medium">shopping_basket</Icon>,
      route: "/dashboard",
      component: <ProtectedRoute check="logout"><Dashboard /></ProtectedRoute>,
      noCollapse: true,
    },
    {
      type: "collapse",
      name: "Super Admin",
      key: "Super Admin",
      icon: <MDAvatar src={profilePicture} alt="Super Admin" size="sm" />,
      collapse: [
        {
          name: "My Profile",
          key: "my-profile",
          route: "/admin/viewProfile",
          component: <ProtectedRoute check="logout"><ViewProfile /></ProtectedRoute>,
        },
        {

          name: "Logout",
          key: "logout",
          route: "/admin/logout",
          component: <LogOut />,

        },
      ],
    },

    { type: "divider", key: "divider-0" },

    {
      type: "collapse",
      name: "Roles",
      key: "roles",
      icon: <Icon fontSize="small">people</Icon>,
      collapse: [
        {
          name: "Manage Roles",
          key: "manage-roles",
          route: "role/manage/",
          component: <ProtectedRoute check="logout"><ManageRoles /></ProtectedRoute>,
        },
        {
          name: "Add Role",
          key: "add-role",
          route: "/role/create",
          component: <ProtectedRoute check="logout"><Role /></ProtectedRoute>,
        },

      ],
    },

    {
      type: "collapse",
      name: "Subadmins",
      key: "subadmins",
      icon: <Icon fontSize="small">people</Icon>,
      collapse: [
        {
          name: "Manage Subadmins",
          key: "manage-subadmins",
          route: "subadmin/manage/",
          component: <ProtectedRoute check="logout"><ManageSubadmins /></ProtectedRoute>,
        },
        {
          name: "Add Subadmin",
          key: "add-subadmin",
          route: "/subadmin/add",
          component: <ProtectedRoute check="logout"><Subadmin /></ProtectedRoute>,
        },

      ],
    },

    { type: "divider", key: "divider-1" },

    {
      type: "collapse",
      name: "Configurations",
      key: "Configurations",
      icon: <SettingsIcon />,
      collapse: [
        {
          name: "Settings",
          key: "profile-settings",
          route: "/admin/viewSettings",
          component: <ProtectedRoute check="logout"><ViewSettings /></ProtectedRoute>,
        },
        {
          name: "Email Templates",
          key: "Email Templates-settings",
          route: "/admin/emailTemplates",
          component: <ProtectedRoute check="logout"><EmailTemplates /></ProtectedRoute>,
        },
      ],
    },

    {
      type: "collapse",
      name: "Categories",
      key: "Categories",
      icon: <CategoryIcon />,
      collapse: [
        {
          name: "Product categories",
          key: "manage-pdt-category",
          route: "productCategory/list",
          component: <ProtectedRoute check="logout"><ManageCategories props={{ 'type': CATEGORY.PRODUCT }} /></ProtectedRoute>,
        },
        {
          name: "Add product category",
          key: "add-pdt-category",
          route: "productCategory/add",
          component: <ProtectedRoute check="logout"><AddCategory props={{ 'type': CATEGORY.PRODUCT }} /></ProtectedRoute>,
        },
        {
          name: "Service categories",
          key: "manage-service-category",
          route: "serviceCategory/list",
          component: <ProtectedRoute check="logout"><ManageCategories props={{ 'type': CATEGORY.SERVICE }} /></ProtectedRoute>,
        },
        {
          name: "Add service category",
          key: "add-service-category",
          route: "serviceCategory/add",
          component: <ProtectedRoute check="logout"><AddCategory props={{ 'type': CATEGORY.SERVICE }} /></ProtectedRoute>,
        },
      ],
    },

    {
      type: "collapse",
      name: "Collections",
      key: "Collection",
      icon: <CollectionsIcon />,
      collapse: [
        {
          name: "Product collections",
          key: "manage-pdt-collection",
          route: "productCollection/list",
          component: <ProtectedRoute check="logout"><ManageCollections props={{ 'type': COLLECTION.PRODUCT }} /></ProtectedRoute>,
        },
        {
          name: "Add product collection",
          key: "add-pdt-collection",
          route: "productCollection/add",
          component: <ProtectedRoute check="logout"><AddCollection props={{ 'type': COLLECTION.PRODUCT }} /></ProtectedRoute>,
        },
        {
          name: "Service collections",
          key: "manage-service-collection",
          route: "serviceCollection/list",
          component: <ProtectedRoute check="logout"><ManageCollections props={{ 'type': COLLECTION.SERVICE }} /></ProtectedRoute>,
        },
        {
          name: "Add service collection",
          key: "add-service-collection",
          route: "serviceCollection/add",
          component: <ProtectedRoute check="logout"><AddCollection props={{ 'type': COLLECTION.SERVICE }} /></ProtectedRoute>,
        },
      ],
    },

    {
      type: "collapse",
      name: "Custom Fields",
      key: "custom fields",
      icon: <DashboardCustomizeIcon />,
      collapse: [
        {
          name: "Product Fields",
          key: "manage-pdt-custom",
          route: "productCustomfield/manage",
          component: <ProtectedRoute check="logout"><ManageCustomField props={{ 'type': CUSTOM_FIELD.PRODUCT }} /></ProtectedRoute>,
        },
        {
          name: "New Product Field",
          key: "add-pdt-cf",
          route: "productCustomfield/add",
          component: <ProtectedRoute check="logout"><AddCustomField props={{ 'type': CUSTOM_FIELD.PRODUCT }} /></ProtectedRoute>,
        },
        {
          name: "Service Fields",
          key: "manage-service-custom",
          route: "serviceCustomfield/manage",
          component: <ProtectedRoute check="logout"><ManageCustomField props={{ 'type': CUSTOM_FIELD.SERVICE }} /></ProtectedRoute>,
        },
        {
          name: "New Service Field",
          key: "add-pdt-service-cf",
          route: "serviceCustomfield/add",
          component: <ProtectedRoute check="logout"><AddCustomField props={{ 'type': CUSTOM_FIELD.SERVICE }} /></ProtectedRoute>,
        },
        {
          name: "Vendor Fields",
          key: "manage-v-custom",
          route: "vendorCustomfield/manage",
          component: <ProtectedRoute check="logout"><ManageCustomField props={{ 'type': CUSTOM_FIELD.VENDOR }} /></ProtectedRoute>,
        },
        {
          name: "New Vendor Field",
          key: "add-v-service-cf",
          route: "vendorCustomfield/add",
          component: <ProtectedRoute check="logout"><AddCustomField props={{ 'type': CUSTOM_FIELD.VENDOR }} /></ProtectedRoute>,
        },
      ],
    },

    { type: "divider", key: "divider-2" },

    {
      type: "collapse",
      name: "Customers",
      key: "manage-Customer",
      icon: <PersonPinCircleSharpIcon />,
      route: "/customer/list",
      component: <ProtectedRoute check="logout"><CustomerList /></ProtectedRoute>,
      noCollapse: true,
    },

    {
      type: "collapse",
      name: "Vendors",
      key: "Vendors",
      icon: <Person4Icon />,
      collapse: [
        {
          name: "Manage Vendors",
          key: "manage-vendors",
          route: "vendor/list/",
          component: <ProtectedRoute check="logout"><ManageVendors /></ProtectedRoute>,
        },
        {
          name: "New vendor",
          key: "new-vendors",
          route: "vendor/add/",
          component: <ProtectedRoute check="logout"><AddVendor /></ProtectedRoute>,
        },
        {
          name: "Withdrawal Requests",
          key: "Withdrawa-Requests",
          route: "withdrawal/list/",
          component: <ProtectedRoute check="logout"><ManageWithdrawals /></ProtectedRoute>,
        }
      ]
    },

    {
      type: "collapse",
      name: "Tickets",
      key: "tickets",
      icon: <ChatIcon />,
      collapse: [
        {
          name: "Vendor Tickets",
          key: "vendor-tickets",
          route: "/tickets/vendorTicket",
          component: <ProtectedRoute check="logout"><ManageTickets props={{ 'type': "vendor" }} /></ProtectedRoute>,
        },
        {
          name: "Customer Tickets",
          key: "customer-tickets",
          route: "/tickets/customerTicket",
          component: <ProtectedRoute check="logout"><ManageTickets props={{ 'type': "customer" }} /></ProtectedRoute>,
        },
      ],
    },

    { type: "divider", key: "divider-3" },

    {
      type: "collapse",
      name: "Products",
      key: "products",
      icon: <Icon fontSize="small">category</Icon>,
      collapse: [
        {
          name: "Manage Products",
          key: "manage products",
          route: "products/manage",
          component: <ProtectedRoute check="logout"><ManageProducts /></ProtectedRoute>,
        },
        {
          name: "Add Product",
          key: "add product",
          route: "products/add",
          component: <ProtectedRoute check="logout"><Product /></ProtectedRoute>,
        },
        {
          name: "Bulk Upload Product",
          key: "bulk upload product",
          route: "products/bulkUpload",
          component: <ProtectedRoute check="logout"><BulkUpload /></ProtectedRoute>,
        },
      ],
    },

    {
      type: "collapse",
      name: "Services",
      key: "services",
      icon: <Icon fontSize="small">category</Icon>,
      collapse: [
        {
          name: "Manage Services",
          key: "manage services",
          route: "services/manage",
          component: <ProtectedRoute check="logout"><ManageServices /></ProtectedRoute>,
        },
        {
          name: "Add Service",
          key: "add service",
          route: "services/add",
          component: <ProtectedRoute check="logout"><Service /></ProtectedRoute>,
        },
      ],
    },

    {
      type: "collapse",
      name: "Reviews",
      key: "reviews",
      icon: <ReviewsIcon />,
      route: "/review/list",
      component: <ProtectedRoute check="logout"><ProductReviews /></ProtectedRoute>,
      noCollapse: true,
    },

    { type: "divider", key: "divider-4" },

    {
      type: "collapse",
      name: "Orders",
      key: "manage-orders",
      icon: <Icon fontSize="medium">shopping_basket</Icon>,
      route: "/order/list",
      component: <List />,
      noCollapse: true,
    },

    {
      type: "collapse",
      name: "Returns",
      key: "return-requests",
      icon: <AssignmentReturnIcon />,
      route: "/returns/list",
      component: <ProtectedRoute check="logout"><ReturnRequests /></ProtectedRoute>,
      noCollapse: true,
    },

    {
      type: "collapse",
      name: "Refunds",
      key: "refunds",
      icon: <AccountBalanceWalletIcon />,
      route: "/refunds/list",
      component: <ProtectedRoute check="logout"><Refunds /></ProtectedRoute>,
      noCollapse: true,
    },

    { type: "divider", key: "divider-5" },

    {
      type: "collapse",
      name: "System Logs",
      key: "Log-Information",
      icon: <WebStoriesIcon />,
      route: "/admin/infoLog",
      component: <ProtectedRoute check="logout"><InfoLog /></ProtectedRoute>,
      noCollapse: true,
    },

    { type: "divider", key: "divider-6" },
  ];

}
else {
  routes = [
    {
      type: "collapse",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="medium">shopping_basket</Icon>,
      route: "/dashboard",
      component: <ProtectedRoute check="logout"><Dashboard /></ProtectedRoute>,
      noCollapse: true,
    },

    {
      type: "collapse",
      name: "Admin",
      key: "Admin",
      icon: <MDAvatar src={profilePicture} alt="Admin" size="sm" />,
      collapse: [
        {
          name: "My Profile",
          key: "my-profile",
          route: "/admin/viewProfile",
          component: <ProtectedRoute check="logout"><ViewProfile name="changePassword" /></ProtectedRoute>,
        },
        {

          name: "Logout",
          key: "logout",
          route: "/admin/logout",
          component: <LogOut />,

        },
      ],
    },

    { type: "divider", key: "divider-0" },
  ];

  if (checkPrivilege("role")) {
    const newRoutes = {
      type: "collapse",
      name: "Roles",
      key: "roles",
      icon: <Icon fontSize="small">people</Icon>,
      collapse: [],
    };

    if (checkPrivilege("role", "read") || checkPrivilege("role", "write") || checkPrivilege("role", "delete")) {
      const additionalCollapseItem = [{
        name: "Manage Roles",
        key: "manage-roles",
        route: "role/manage/",
        component: <ProtectedRoute check="logout"><ManageRoles /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }

    if (checkPrivilege("role", "write")) {
      const additionalCollapseItem = [{
        name: "Add Role",
        key: "add-role",
        route: "/role/create",
        component: <ProtectedRoute check="logout"><Role /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    routes = [...routes, newRoutes];

  }

  if (checkPrivilege("subadmin")) {
    const newRoutes = {
      type: "collapse",
      name: "Subadmins",
      key: "subadmins",
      icon: <Icon fontSize="small">people</Icon>,
      collapse: [],
    };

    if (checkPrivilege("subadmin", "read") || checkPrivilege("subadmin", "write") || checkPrivilege("subadmin", "delete")) {
      const additionalCollapseItem = [{
        name: "Manage Subadmins",
        key: "manage-subadmins",
        route: "subadmin/manage/",
        component: <ProtectedRoute check="logout"><ManageSubadmins /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }

    if (checkPrivilege("subadmin", "write")) {
      const additionalCollapseItem = [{
        name: "Add Subadmin",
        key: "add-subadmin",
        route: "/subadmin/add",
        component: <ProtectedRoute check="logout"><Subadmin /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    routes = [...routes, newRoutes];

  }

  if (checkPrivilege("configuration")) {
    const newRoutes = {
      type: "collapse",
      name: "Configurations",
      key: "Configurations",
      icon: <SettingsIcon />,
      collapse: [],
    };

    if (checkPrivilege("configuration", "read") || checkPrivilege("configuration", "write")) {
      const additionalCollapseItem = [{
        name: "Settings",
        key: "profile-settings",
        route: "/admin/viewSettings",
        component: <ProtectedRoute check="logout"><ViewSettings /></ProtectedRoute>,
      },
      {
        name: "Email Templates",
        key: "Email Templates-settings",
        route: "/admin/emailTemplates",
        component: <ProtectedRoute check="logout"><EmailTemplates /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    routes = [...routes, newRoutes];

  }

  if (checkPrivilege("category")) {
    const newRoutes = {
      type: "collapse",
      name: "Categories",
      key: "Categories",
      icon: <CategoryIcon />,
      collapse: [],
    };

    if (checkPrivilege("category", "read") || checkPrivilege("category", "write") || checkPrivilege("category", "delete")) {
      const additionalCollapseItem = [{
        name: "Product categories",
        key: "manage-pdt-category",
        route: "productCategory/list",
        component: <ProtectedRoute check="logout"><ManageCategories props={{ 'type': CATEGORY.PRODUCT }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }

    if (checkPrivilege("category", "write")) {
      const additionalCollapseItem = [{
        name: "Add product category",
        key: "add-pdt-category",
        route: "productCategory/add",
        component: <ProtectedRoute check="logout"><AddCategory props={{ 'type': CATEGORY.PRODUCT }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }

    if (checkPrivilege("category", "read") || checkPrivilege("category", "write") || checkPrivilege("category", "delete")) {
      const additionalCollapseItem = [{
        name: "Service categories",
        key: "manage-service-category",
        route: "serviceCategory/list",
        component: <ProtectedRoute check="logout"><ManageCategories props={{ 'type': CATEGORY.SERVICE }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }

    if (checkPrivilege("category", "write")) {
      const additionalCollapseItem = [{
        name: "Add service category",
        key: "add-service-category",
        route: "serviceCategory/add",
        component: <ProtectedRoute check="logout"><AddCategory props={{ 'type': CATEGORY.SERVICE }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    routes = [...routes, newRoutes];
  }

  if (checkPrivilege("collection")) {
    const newRoutes = {
      type: "collapse",
      name: "Collections",
      key: "Collection",
      icon: <CollectionsIcon />,
      collapse: [],
    };

    if (checkPrivilege("collection", "read") || checkPrivilege("collection", "write") || checkPrivilege("collection", "delete")) {
      const additionalCollapseItem = [{
        name: "Product collections",
        key: "manage-pdt-collection",
        route: "productCollection/list",
        component: <ProtectedRoute check="logout"><ManageCollections props={{ 'type': COLLECTION.PRODUCT }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    if (checkPrivilege("collection", "write")) {
      const additionalCollapseItem = [{
        name: "Add product collection",
        key: "add-pdt-collection",
        route: "productCollection/add",
        component: <ProtectedRoute check="logout"><AddCollection props={{ 'type': COLLECTION.PRODUCT }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    if (checkPrivilege("collection", "read") || checkPrivilege("collection", "write") || checkPrivilege("collection", "delete")) {
      const additionalCollapseItem = [{
        name: "Service collections",
        key: "manage-service-collection",
        route: "serviceCollection/list",
        component: <ProtectedRoute check="logout"><ManageCollections props={{ 'type': COLLECTION.SERVICE }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    if (checkPrivilege("collection", "write")) {
      const additionalCollapseItem = [{
        name: "Add service collection",
        key: "add-service-collection",
        route: "serviceCollection/add",
        component: <ProtectedRoute check="logout"><AddCollection props={{ 'type': COLLECTION.SERVICE }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }

    routes = [...routes, newRoutes];

  }

  if (checkPrivilege("customfield")) {
    const newRoutes = {
      type: "collapse",
      name: "Custom Fields",
      key: "custom fields",
      icon: <DashboardCustomizeIcon />,
      collapse: [],
    };
    if (checkPrivilege("customfield", "read") || checkPrivilege("customfield", "write") || checkPrivilege("customfield", "delete")) {
      const additionalCollapseItem = [{
        name: "Product Fields",
        key: "manage-pdt-custom",
        route: "productCustomfield/manage",
        component: <ProtectedRoute check="logout"><ManageCustomField props={{ 'type': CUSTOM_FIELD.PRODUCT }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    if (checkPrivilege("customfield", "write")) {
      const additionalCollapseItem = [{
        name: "New Product Field",
        key: "add-pdt-cf",
        route: "productCustomfield/add",
        component: <ProtectedRoute check="logout"><AddCustomField props={{ 'type': CUSTOM_FIELD.PRODUCT }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    if (checkPrivilege("customfield", "read") || checkPrivilege("customfield", "write") || checkPrivilege("customfield", "delete")) {
      const additionalCollapseItem = [{
        name: "Service Fields",
        key: "manage-service-custom",
        route: "serviceCustomfield/manage",
        component: <ProtectedRoute check="logout"><ManageCustomField props={{ 'type': CUSTOM_FIELD.SERVICE }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    if (checkPrivilege("customfield", "write")) {
      const additionalCollapseItem = [{
        name: "New Service Field",
        key: "add-pdt-service-cf",
        route: "serviceCustomfield/add",
        component: <ProtectedRoute check="logout"><AddCustomField props={{ 'type': CUSTOM_FIELD.SERVICE }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    if (checkPrivilege("customfield", "read") || checkPrivilege("customfield", "write") || checkPrivilege("customfield", "delete")) {
      const additionalCollapseItem = [{
        name: "Vendor Fields",
        key: "manage-v-custom",
        route: "vendorCustomfield/manage",
        component: <ProtectedRoute check="logout"><ManageCustomField props={{ 'type': CUSTOM_FIELD.VENDOR }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    if (checkPrivilege("customfield", "write")) {
      const additionalCollapseItem = [{
        name: "New Vendor Field",
        key: "add-v-service-cf",
        route: "vendorCustomfield/add",
        component: <ProtectedRoute check="logout"><AddCustomField props={{ 'type': CUSTOM_FIELD.VENDOR }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    routes = [...routes, newRoutes];
  }

  if (checkPrivilege("customer") && checkPrivilege("customer", "read")) {
    const newRoutes = {
      type: "collapse",
      name: "Customers",
      key: "manage-Customer",
      icon: <PersonPinCircleSharpIcon />,
      route: "/customer/list",
      component: <ProtectedRoute check="logout"><CustomerList /></ProtectedRoute>,
      noCollapse: true,
    };
    routes = [...routes, newRoutes];
  }

  if (checkPrivilege("vendor")) {
    const newRoutes = {
      type: "collapse",
      name: "Vendors",
      key: "Vendors",
      icon: <Person4Icon />,
      collapse: []
    };

    if (checkPrivilege("vendor", "read") || checkPrivilege("vendor", "write")) {
      const additionalCollapseItem = [{
        name: "Manage Vendors",
        key: "manage-vendors",
        route: "vendor/list/",
        component: <ProtectedRoute check="logout"><ManageVendors /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    if (checkPrivilege("vendor", "write")) {
      const additionalCollapseItem = [{
        name: "New vendor",
        key: "new-vendors",
        route: "vendor/add/",
        component: <ProtectedRoute check="logout"><AddVendor /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }

    if (checkPrivilege("withdrawal", "read") || checkPrivilege("withdrawal", "write")) {
      const additionalCollapseItem = [{
        name: "Withdrawal Requests",
        key: "Withdrawa-Requests",
        route: "withdrawal/list/",
        component: <ProtectedRoute check="logout"><ManageWithdrawals /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    routes = [...routes, newRoutes];
  }

  if (checkPrivilege("ticket")) {
    const newRoutes = {
      type: "collapse",
      name: "Tickets",
      key: "tickets",
      icon: <ChatIcon />,
      collapse: [],
    };

    if (checkPrivilege("ticket", "read")) {
      const additionalCollapseItem = [{
        name: "Vendor Tickets",
        key: "vendor-tickets",
        route: "/tickets/vendorTicket",
        component: <ProtectedRoute check="logout"><ManageTickets props={{ 'type': "vendor" }} /></ProtectedRoute>,
      },
      {
        name: "Customer Tickets",
        key: "customer-tickets",
        route: "/tickets/customerTicket",
        component: <ProtectedRoute check="logout"><ManageTickets props={{ 'type': "customer" }} /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    routes = [...routes, newRoutes];
  }


  if (checkPrivilege("product")) {
    const newRoutes = {
      type: "collapse",
      name: "Products",
      key: "products",
      icon: <Icon fontSize="small">category</Icon>,
      collapse: [],
    };

    if (checkPrivilege("product", "read") || checkPrivilege("product", "write") || checkPrivilege("product", "delete")) {
      const additionalCollapseItem = [{
        name: "Manage Products",
        key: "manage products",
        route: "products/manage",
        component: <ProtectedRoute check="logout"><ManageProducts /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    if (checkPrivilege("product", "write")) {
      const additionalCollapseItem = [{
        name: "Add Product",
        key: "add product",
        route: "products/add",
        component: <ProtectedRoute check="logout"><Product /></ProtectedRoute>,
      },
      {
        name: "Bulk Upload Product",
        key: "bulk upload product",
        route: "products/bulkUpload",
        component: <ProtectedRoute check="logout"><BulkUpload /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    routes = [...routes, newRoutes];
  }

  if (checkPrivilege("service")) {
    const newRoutes = {
      type: "collapse",
      name: "Services",
      key: "services",
      icon: <Icon fontSize="small">category</Icon>,
      collapse: [],
    };

    if (checkPrivilege("service", "read") || checkPrivilege("service", "write") || checkPrivilege("service", "delete")) {
      const additionalCollapseItem = [{
        name: "Manage Services",
        key: "manage services",
        route: "services/manage",
        component: <ProtectedRoute check="logout"><ManageServices /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    if (checkPrivilege("service", "write")) {
      const additionalCollapseItem = [{
        name: "Add Service",
        key: "add service",
        route: "services/add",
        component: <ProtectedRoute check="logout"><Service /></ProtectedRoute>,
      }];
      additionalCollapseItem.forEach(item => newRoutes.collapse.push(item));
    }
    routes = [...routes, newRoutes];
  }

  if (checkPrivilege("review", "read") || checkPrivilege("review", "write")) {
    const newRoutes = {
      type: "collapse",
      name: "Reviews",
      key: "reviews",
      icon: <ReviewsIcon />,
      route: "/review/list",
      component: <ProtectedRoute check="logout"><ProductReviews /></ProtectedRoute>,
      noCollapse: true,
    };
    routes = [...routes, newRoutes];
  }

  if (checkPrivilege("order", "read")) {
    const newRoutes = {
      type: "collapse",
      name: "Orders",
      key: "manage-orders",
      icon: <Icon fontSize="medium">shopping_basket</Icon>,
      route: "/order/list",
      component: <List />,
      noCollapse: true,
    };
    routes = [...routes, newRoutes];
  }

  if (checkPrivilege("return", "read")) {
    const newRoutes = {
      type: "collapse",
      name: "Returns",
      key: "return-requests",
      icon: <AssignmentReturnIcon />,
      route: "/returns/list",
      component: <ProtectedRoute check="logout"><ReturnRequests /></ProtectedRoute>,
      noCollapse: true,
    };
    routes = [...routes, newRoutes];
  }

  if (checkPrivilege("refund") && checkPrivilege("refund", "read")) {
    const newRoutes = {
      type: "collapse",
      name: "Refunds",
      key: "refunds",
      icon: <AccountBalanceWalletIcon />,
      route: "/refunds/list/",
      component: <ProtectedRoute check="logout"><Refunds /></ProtectedRoute>,
      noCollapse: true,
    }
    routes = [...routes, newRoutes];
  }

  if (checkPrivilege("log") && checkPrivilege("log", "read")) {
    const newRoutes = {
      type: "collapse",
      name: "System Logs",
      key: "systemLogs",
      icon: <WebStoriesIcon />,
      route: "/admin/infoLog",
      component: <ProtectedRoute check="logout"><InfoLog /></ProtectedRoute>,
      noCollapse: true,
    }
    routes = [...routes, newRoutes];
  }

}

export default routes;
